module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.4817b66e.eot";